<template>
  <div class="contractor-details-display">
    <div class="row">
      <div v-if="$user.administrator" class="col-md-4">
        <div class="card mb-5">
          <h4 class="card-header">
            <i class="fa fa-fw fa-briefcase"></i> Contractor Details
          </h4>
          <div class="card-body">
            <responsive-table
              :collapse="false"
              :hideColumns="true">
              <template slot="rows">
                <tr>
                  <td colspan="2">
                    <h4>{{ contractor.dropdownLabel }}</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Phone</strong>
                  </td>
                  <td>{{ contractor.mobilePhone ? contractor.mobilePhone : 'N/A' }} </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h4><i class="far fa-envelope"></i> Postal Address</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Address</strong>
                  </td>
                  <td>{{ contractor.address }}</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <h4><i class="far fa-building"></i> Company</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Company/Trading Name</strong>
                  </td>
                  <td>{{ contractor.Company && contractor.Company.name ? contractor.Company.name : 'N/A' }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>ABN</strong>
                  </td>
                  <td>{{ contractor.Company && contractor.Company.abn ? contractor.Company.abn : 'N/A' }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Address</strong>
                  </td>
                  <td>{{ contractor.Company && contractor.Company.address ? contractor.Company.address : 'N/A' }}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Web Address</strong>
                  </td>
                  <td>{{ contractor.Company && contractor.Company.webAddress ? contractor.Company.webAddress : 'N/A' }}</td>
                </tr>
              </template>
            </responsive-table>
          </div>
        </div>
      </div>
      <div class="col">
        <nav-tabs>
          <tab name="Work History" icon="fa fa-history">
             <search-form
              ref="workHistorySearchForm"
              showSearch
              searchHidden
              showPaging
              :redirectUrl="`${$route.path}#work-history`"
              :options="{
                permalink: 'workSummary',
                params: {
                  uuid: $route.params.AssigneeUuid ? $route.params.AssigneeUuid : null
                }
              }">
            </search-form>
          </tab>
          <tab name="Assigned Quotes" icon="fa fa-address-book">
            <search-form
              ref="assignedQuotesSearchForm"
              showSearch
              searchHidden
              showPaging
              tableDisplay
              :redirectUrl="`${$route.path}#assigned-quotes`"
              :options="{
                permalink: 'assignedQuotes',
                params: {
                  assignedToUuid: $route.params.AssigneeUuid ? $route.params.AssigneeUuid : null
                }
              }">
            </search-form>
          </tab>
        </nav-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import Dropdown from '@/components/ui/Dropdown'
  import NavTabs from '@/components/ui/NavTab'
  import Tab from '@/components/ui/Tab'
  import SearchForm from '@/components/SearchForm'
  import ResponsiveTable from '@/components/ui/ResponsiveTable'
  import Api from '@/vuex/api'
  const api = new Api()
  export default {
    name: 'ContractorDetailsDisplay',
    components: {
      Dropdown,
      NavTabs,
      Tab,
      ResponsiveTable,
      SearchForm
    },
    data () {
      return {
        contractor: {}
      }
    },
    computed: {
      hasAdminPrivilege () {
        return this.$user.administrator
      }
    },
    async mounted () {
      /**
       * API call will be made for admin interface as path param will be provided
       * and not for contractor interface NOTE//: May need to do changes in App.vue
       * if this method is no longer suitable
       */
      if (this.$route.params.AssigneeUuid) {
        this.contractor = await api.getContractor(this.$route.params.AssigneeUuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/ContractorDetailsDisplay.vue